import script from "./SuggestionsFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestionsFormPage.vue?vue&type=script&setup=true&lang=js"

import "./SuggestionsFormPage.vue?vue&type=style&index=0&id=25390ad5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25390ad5"]])

export default __exports__